import pubfooter from './pubfooter.vue'
export default pubfooter